import { createAction, props } from '@ngrx/store';

import type { TodoCreatePayload, TodoItem, TodoReorderPayload, TodoUpdatePayload } from './todo.models';

export const TodoClearStatus = createAction('[Todo] Clear Status');

export const TodoItemsFetchRequest = createAction('[Todo] Items Fetch Request');
export const TodoItemsFetchSuccess = createAction('[Todo] Items Fetch Success', props<{ items: TodoItem[] }>());
export const TodoItemsFetchFailure = createAction('[Todo] Items Fetch Failure', props<{ error: string }>());

export const TodoCreateRequest = createAction('[Todo] Create Request', props<{ payload: TodoCreatePayload }>());
export const TodoCreateSuccess = createAction('[Todo] Create Success', props<{ item: TodoItem }>());
export const TodoCreateFailure = createAction('[Todo] Create Failure', props<{ error: string }>());

export const TodoUpdateRequest = createAction(
  '[Todo] Update Request',
  props<{ todoId: string; payload: TodoUpdatePayload; previousItem: TodoItem }>(),
);
export const TodoUpdateSuccess = createAction('[Todo] Update Success', props<{ item: TodoItem }>());
export const TodoUpdateFailure = createAction('[Todo] Update Failure', props<{ error: string; previousItem: TodoItem }>());

export const TodoReorderRequest = createAction(
  '[Todo] Reorder Request',
  props<{ todoId: string; payload: TodoReorderPayload; previousItems: TodoItem[] }>(),
);
export const TodoReorderSuccess = createAction('[Todo] Reorder Success', props<{ items: TodoItem[] }>());
export const TodoReorderFailure = createAction('[Todo] Reorder Failure', props<{ error: string; previousItems: TodoItem[] }>());

export const TodoDeleteRequest = createAction('[Todo] Delete Request', props<{ todoId: string }>());
export const TodoDeleteSuccess = createAction('[Todo] Delete Success', props<{ todoId: string }>());
export const TodoDeleteFailure = createAction('[Todo] Delete Failure', props<{ error: string }>());
